module.exports = __webpack_public_path__ + "static/img/ussc-second-icon.2adb182c.png";